<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M12.2499 11.5001C12.6641 11.5001 12.9999 11.8359 12.9999 12.2501C12.9998 12.6643 12.6641 13.0001 12.2499 13.0001H3.74989C3.33575 13.0001 2.99995 12.6643 2.99989 12.2501C2.99989 11.8359 3.33571 11.5002 3.74989 11.5001H12.2499Z"
      fill="#747474"
    />
    <path
      d="M10.7499 9.00013C11.1641 9.00013 11.4999 9.33592 11.4999 9.75013C11.4998 10.1643 11.1641 10.5001 10.7499 10.5001H5.24989C4.83575 10.5001 4.49995 10.1643 4.49989 9.75013C4.49989 9.33595 4.83571 9.00018 5.24989 9.00013H10.7499Z"
      fill="#747474"
    />
    <path
      d="M9.24989 6.50013C9.6641 6.50013 9.99989 6.83592 9.99989 7.25013C9.99983 7.66429 9.66407 8.00013 9.24989 8.00013H6.74989C6.33575 8.00009 5.99995 7.66427 5.99989 7.25013C5.99989 6.83595 6.33571 6.50018 6.74989 6.50013L9.24989 6.50013Z"
      fill="#747474"
    />
    <path
      d="M7.99989 4.00013C8.4141 4.00013 8.74989 4.33592 8.74989 4.75013C8.74983 5.16429 8.41407 5.50013 7.99989 5.50013C7.58575 5.50009 7.24995 5.16427 7.24989 4.75013C7.24989 4.33594 7.58571 4.00018 7.99989 4.00013Z"
      fill="#747474"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.82948 3.29115C6.78922 1.61161 9.21057 1.61161 10.1703 3.29115L14.724 11.2599C15.6763 12.9265 14.4731 15.0001 12.5536 15.0001H3.44618C1.52676 15 0.323585 12.9265 1.27577 11.2599L5.82948 3.29115ZM9.30214 3.78724C8.72629 2.77952 7.27349 2.77952 6.69764 3.78724L2.14393 11.756C1.5727 12.7559 2.29459 14 3.44618 14.0001H12.5536C13.7053 14.0001 14.4272 12.7559 13.8558 11.756L9.30214 3.78724Z"
      fill="#747474"
    />
  </svg>
</template>
